import React from 'react';
import { Share2, Link2, Send, MessageCircle } from 'lucide-react';
import { toast } from 'sonner';

const XIcon = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export const ShareButtons = ({ title, url }) => {
  const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  const text = encodeURIComponent(title || 'Check this out on DigitalGoldGang');
  const encodedUrl = encodeURIComponent(shareUrl);

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success('Link copied to clipboard');
    } catch {
      toast.error('Could not copy link');
    }
  };

  const btnClass = 'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium bg-white/5 border border-white/10 text-gray-300 hover:text-white hover:border-[#C5A059]/50 hover:bg-[#C5A059]/10 transition-all';

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="share-buttons">
      <span className="inline-flex items-center gap-1.5 text-gray-500 text-xs mr-1">
        <Share2 size={13} /> Share
      </span>
      <a href={`https://twitter.com/intent/tweet?text=${text}&url=${encodedUrl}`} target="_blank" rel="noopener noreferrer"
        className={btnClass} data-testid="share-x">
        <XIcon /> X
      </a>
      <a href={`https://t.me/share/url?url=${encodedUrl}&text=${text}`} target="_blank" rel="noopener noreferrer"
        className={btnClass} data-testid="share-telegram">
        <Send size={13} /> Telegram
      </a>
      <a href={`https://wa.me/?text=${text}%20${encodedUrl}`} target="_blank" rel="noopener noreferrer"
        className={btnClass} data-testid="share-whatsapp">
        <MessageCircle size={13} /> WhatsApp
      </a>
      <button onClick={copyLink} className={btnClass} data-testid="share-copy-link">
        <Link2 size={13} /> Copy Link
      </button>
    </div>
  );
};

export default ShareButtons;
